import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'day8-ui';
import { getUniqueYearsFromWeeks } from '../../../../helpers/week';
import {
  clearFilter,
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';
import { IoCalendarClearOutline } from "@react-icons/all-files/io5/IoCalendarClearOutline";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

const Year = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  // const selectedYears = getSelectedFilters(history.location)[FILTERS.YEAR];
  // useEffect(() => {
  //   if (selectedYears.length < 1 && yearsOptions.length > 0) {
  //     onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.YEAR, yearsOptions[0]);
  //   }
  // }, []);
  const yearsOptions = getUniqueYearsFromWeeks(props.weeks).sort((a, b) => a - b).map(year => year.toString());
  const selectedYears = getSelectedFilters(history.location)[FILTERS.YEAR];
  const selectedFilterText = selectedYears.join(', ');
  const isShowAllActive = selectedYears.length === 0;
  const handleYearSelect = item => {
    clearFilter(dispatch, props.filterAction, FILTERS.YEAR);
    onFilterSelect(history.location, dispatch, props.filterAction, FILTERS.YEAR, item);
  };
  const handleShowAll = () => {
    if (selectedYears.length > 0) {
      clearFilter(dispatch, props.filterAction, FILTERS.YEAR);
    }
  };
  if (yearsOptions.length === 1) return null;
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Year</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        <Button buttonType={isShowAllActive ? "FILTER_ACTIVE" : "FILTER"} onClick={handleShowAll}>Show all</Button>
        {yearsOptions.map(item => (
          <Button key={JSON.stringify(item)} buttonType={isFilterSelected(history.location, FILTERS.YEAR, item) ? "FILTER_ACTIVE" : "FILTER"} onClick={() => handleYearSelect(item)}>{item}</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<IoCalendarClearOutline />}>{selectedFilterText || 'Year'}</Button>;
};
Year.propTypes = {
  weeks: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterAction: PropTypes.func.isRequired,
  filterModalToggle: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default Year;
